var render, staticRenderFns
import script from "./SettingsMixin.vue?vue&type=script&lang=js"
export * from "./SettingsMixin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530274cc')) {
      api.createRecord('530274cc', component.options)
    } else {
      api.reload('530274cc', component.options)
    }
    
  }
}
component.options.__file = "src/mixins/SettingsMixin.vue"
export default component.exports